import { render, staticRenderFns } from "./ContractorCommunications.vue?vue&type=template&id=09de5255&"
import script from "./ContractorCommunications.vue?vue&type=script&lang=js&"
export * from "./ContractorCommunications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports